import { useState, useEffect } from 'react'
import { apiService } from '../services/apiService'

/**
 * Хук для получения актуальной статистики HR системы
 */
export const useStats = () => {
  const [stats, setStats] = useState({
    departments: 0,
    positions: 0,
    transitions: 0,
    loading: true,
    error: null
  })

  const loadStats = async () => {
    try {
      setStats(prev => ({ ...prev, loading: true, error: null }))
      
      // Ждем инициализации API сервиса
      if (!apiService.isInitialized) {
        await apiService.init()
      }

      // Получаем статистику через API
      const statsResponse = await apiService.getStats()
      
      if (statsResponse && statsResponse.success) {
        const { database: dbStats } = statsResponse.data
        
        setStats({
          departments: dbStats.departments || 0,
          positions: dbStats.positions || 0,
          transitions: dbStats.transitions || 0,
          loading: false,
          error: null
        })
      } else {
        throw new Error(`Неверный ответ API: ${JSON.stringify(statsResponse)}`)
      }
    } catch (error) {
      console.error('❌ useStats: Ошибка загрузки статистики:', error)
      setStats(prev => ({
        ...prev,
        loading: false,
        error: error.message
      }))
    }
  }

  useEffect(() => {
    loadStats()
  }, [])

  return {
    ...stats,
    refresh: loadStats
  }
}

export default useStats 